import { Performer } from '../../core/performer'
import { HttpMethod } from '../../core/types'
import type { AuthResponse, LoginRequest } from './model'

export class Login extends Performer<
  {
    payload: LoginRequest
  },
  AuthResponse
> {
  protected method = HttpMethod.POST
  protected url = '/auth/login'
}

export default new Login().perform
